import { TEngineeri8EnvironmentVars } from '@monorepo/types';

export const environment: TEngineeri8EnvironmentVars = {
  appType: 'E8_APP',
  production: false,
  mode: 'kalpha',
  protocol: 'https://',
  // DevOps-confirmed kalpha host (n- prefix, matches the provisioned ingress + backend client_endpoint)
  service_host: 'kalpha-n-engineeri8-web-external.strawmine.com',
  auth_services: '/auth_services/ext',
  engineeri8: '/engineeri8/ext',
  unified_login: 'auth.strawmine.com',
  data_gateway: '/app_data_gateway_n2/ext',
};
